import { Wording } from '@/types';

export const FITNESS_WORDING_BG: Wording = {
  components_header_media_content: 'Тренировки',
  components_header_media_1: 'За мъжете',
  components_header_media_2: 'За жени',
  components_header_text1: 'Рецепти',
  components_header_text2: 'Блог',
  components_header_members: 'Членове',
  hero_text: 'Поддържайте тялото си във форма и силно',
  hero_button_text: 'Започнете вашето фитнес пътуване',
  components_ressources_section_title: 'РЕСУРСИ',
  components_ressources_subheader_text:
    'Всички ресурси, от които се нуждаете за здравословен живот',
  components_ressources_span_text:
    'Подхранвайте благосъстоянието си: Отприщване на изобилие от ресурси за холистично здраве и пълноценен живот, включително експертни насоки за фитнес, хранене и устойчив начин на живот.',
  components_ressources_card_1_title: 'Мотивация',
  components_ressources_card_1_text:
    'Кратки изблици на мотивация за трайни навици за упражнения.',
  components_ressources_card_2_title: 'диета',
  components_ressources_card_2_text:
    'Интелигентни съвети за хранене за по-здрави и по-силни.',
  components_ressources_link: 'Гледайте видеоклипове',
  components_notes_and_google_title_1: 'Фитнес обучение',
  components_notes_and_google_title_2: 'Редовна рутина',
  components_notes_and_google_title_3: 'Поддържане на диета',
  components_review_google_text: 'Преглед в Google',
  media_content_section_title: 'ТРЕНИРОВКИ',
  media_content_section_subheader_text: 'Нашите видеоклипове',
  text_media_1: 'мъже',
  text_media_2: 'жени',
  media_content_section_button_more: 'Още видеоклипове',
  text2_section_title: 'БЛОГ',
  text2_section_subheader_text: 'Статии и новини',
  text2_section_button_more: 'Още статии',
  components_text1_section_title: 'РЕЦЕПТИ',
  components_text1_subheader_text: 'Здравословна диета за вашия активен живот',
  components_text1_span_text:
    'Готвене на жизненост: Изследвайте свят на ароматен фитнес с нашите бързи и пълни с хранителни вещества рецепти.',
  components_text1_card_1_title: 'Ускорете деня си',
  components_text1_card_1_text:
    'Започнете сутринта си правилно с богати на хранителни вещества и протеини опции за закуска.',
  components_text1_card_3_title: 'Пакетирани обяди',
  components_text1_card_3_text:
    'Открийте вкусни и удобни рецепти за обяд, предназначени за вашия активен начин на живот. От цветни салати до опаковани с протеини опаковки, тези рецепти ви държат заредени и фокусирани.',
  components_text1_card_2_title: 'Вечери за възстановяване',
  components_text1_card_2_text:
    'Разгледайте разнообразие от постни протеини, пълнозърнести храни и живи зеленчуци за задоволителен завършек на деня ви.',
  components_text1_link: 'Вижте всички рецепти',
  components_footer_text:
    'Увеличете силата си, запалете страстта си: Вашата фитнес зала, Вашата трансформация.',
  components_footer_info: 'Информация',
  components_footer_registration_number: 'Регистрационен номер',
  components_footer_legal: 'Законни',
  components_footer_terms: 'Правила и условия',
  components_footer_privacy: 'Политика за поверителност',
  button_load_more: 'Зареди още',
  page_media_1_content_hero_text: 'Тренировки за мъже',
  page_media_content_menu_all: 'Всички',
  page_media_content_menu_biceps: 'Бицепс',
  page_media_content_menu_triceps: 'Трицепс',
  page_media_content_menu_back: 'Назад',
  page_media_content_menu_chest: 'Гръден кош',
  page_media_content_menu_legs: 'Крака',
  page_media_content_menu_shoulders: 'Рамене',
  page_media_content_menu_abdominals: 'Коремни',
  page_media_2_content_hero_text: 'Женски тренировки',
  page_text1_hero_text: 'Рецепти',
  page_text1_section_title: 'Хранене',
  page_text1_subheader_text: 'Рецепти',
  page_text2_hero_text: 'Нашият блог',
  page_text2_section_title: 'Блог',
  page_text2_subheader_text: 'Статии и новини',
  enter_email_title: 'Моля, въведете вашия имейл, за да продължите',
  enter_email_placeholder_email: 'Имейл',
  enter_email_button_enter: 'Въведете',
  components_login_success_text: 'Успешно влизане!',
  components_card_link_media_content: 'Гледайте сега',
  components_card_link_text1_content: 'Вижте рецепта',
  components_card_link_text2_content: 'Вижте статията',
  france: 'Франция',
  cyprus: 'Кипър',
};
